import { makeStyles } from "@material-ui/core/styles";
import { preDefinedThemeColor } from "./preDefinedColor";
import reportBg from "../../assets/images/downloadReportBg.png";

export const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 700,
    color: "#242A38",
  },
  tabs: {
    padding: 0,
    "& .MuiButtonBase-root": {
      textTransform: "none",
      fontSize: 12,
      color: "#8F8F8F",
      padding: "0",
      marginRight: theme.spacing(1.5),
      marginBottom: "0.4em",
      minWidth: "auto",
      [theme.breakpoints.up("sm")]: {
        fontSize: 16,
        marginRight: theme.spacing(2),
      },
      [theme.breakpoints.up("lg")]: {
        fontSize: "1.35em",
        marginRight: "2.5em",
      },
    },
    "& .MuiButtonBase-root.Mui-selected": {
      color: "#242A38",
    },
    "& .MuiTabs-indicator": {
      height: "4px",
    },
  },
  tabPanel: {
    "& > .MuiBox-root": {
      margin: theme.spacing(3, 0),
    },
  },
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(20),
    flexBasis: "auto",
    flexShrink: 0,
    fontWeight: 900,
  },
  circularProgressSmall: {
    width: `${theme.typography.pxToRem(20)} !important`,
    height: `${theme.typography.pxToRem(20)} !important`,
  },
  accordionSummary: {
    padding: theme.spacing(2.5, 5),
    "& .MuiAccordionSummary-content": {
      alignItems: "center",
      justifyContent: "space-between",
    },
  },
  accordionDetails: {
    padding: theme.spacing(0),
  },
  cardContentWrapper: {
    overflow: "auto",
  },
  cardContent: {
    minWidth: 700,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(4),
    "& > .MuiGrid-root": {
      marginTop: "0.75em",
      marginBottom: "2em",
    },
    "& h1": {
      fontWeight: 500,
      fontSize: "1.5em",
    },
    "&:last-child": {
      padding: theme.spacing(4),
    },
  },
  engagementContainer: {
    margin: "auto",
  },
  cardTitle: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 500,
  },
  cardDate: {
    margin: theme.spacing(2, 0, 4),
    textAlign: "center",
    fontSize: theme.typography.pxToRem(15),
    color: "rgba(174, 178, 186, 1)",
  },
  height100: {
    height: "100%",
  },
  scoreValue: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700,
    color: "#000",
    marginBottom: theme.spacing(0),
  },
  scoreLabel: {
    fontSize: theme.typography.pxToRem(15),
    color: "rgba(174, 178, 186, 1)",
  },
  engagementLabel: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 500,
    color: "rgba(46, 56, 77, 1)",
    display: "inline-flex",
    alignItems: "center",
  },
  colorSuccess: {
    color: theme.palette.success.main,
  },
  colorError: {
    color: theme.palette.error.main,
  },
  scoreChip: {
    fontSize: theme.typography.pxToRem(40),
    fontWeight: 700,
    height: theme.typography.pxToRem(60),
    borderRadius: theme.typography.pxToRem(30),
    padding: theme.spacing(0, 2.5),
    lineHeight: 1,
  },
  chipLarge: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 700,
    height: theme.typography.pxToRem(40),
    borderRadius: 20,
    lineHeight: 1,
  },
  contentEngagementChip: {
    backgroundColor: preDefinedThemeColor.red,
    color: theme.palette.error.contrastText,
    fontSize: theme.typography.pxToRem(40),
    fontWeight: 700,
    height: "100%",
    borderRadius: theme.typography.pxToRem(45),
    padding: "30px 35px 20px",
    marginBottom: "20px",
    lineHeight: 1,
  },
  potentialPenaltyText: {
    marginBottom: 0,
    fontWeight: 500,
  },
  contentEngagementLabel: {
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 500,
    color: "#000000",
  },
  contentEngagementImg: {
    textAlign: "right",
  },
  chipXLarge: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 700,
    height: theme.typography.pxToRem(60),
    borderRadius: 30,
    lineHeight: 1,
  },
  chipError: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    lineHeight: 1,
  },
  headerSubNote: {
    textAlign: "right",
    color: "rgb(175 179 187)",
    fontSize: 10,
    fontWeight: 500,
    marginBottom: 0,
    [theme.breakpoints.up("sm")]: {
      fontSize: 15,
      fontWeight: 400,
    },
  },
  driverRiskList: {
    width: "100%",
    padding: 0,
  },
  driverRiskListItem: {
    borderBottom: "1px solid rgba(0,0,0,.1)",
    padding: theme.spacing(2, 5),
    "&.MuiListItem-root": {
      padding: theme.spacing(2, 5),
    },
  },
  driverRiskListItemText: {
    width: "50%",
    maxWidth: "50%",
    flex: "0 0 50%",
  },
  reportCardChip: {
    backgroundColor: "rgb(255,231,231)",
    padding: "0.3em 1em",
    borderRadius: "1em",
    marginRight: "1em",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    "&:last-child": {
      marginRight: 0,
    },
    [theme.breakpoints.up("md")]: {
      padding: "0.6em 1.5em",
      borderRadius: "2em",
    },
    [theme.breakpoints.up("xl")]: {
      padding: "0.8em 1.85em",
      borderRadius: "3em",
      marginRight: "2em",
    },
  },
  reportCardChipGreen: {
    backgroundColor: "rgb(235,255,215)",
  },
  reportCardChipGray: {
    backgroundColor: "rgb(241,242,246)",
  },
  reportCardChipLabel: {
    fontSize: 12,
    marginRight: 10,
    [theme.breakpoints.up("md")]: {
      fontSize: 16,
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: 20,
      marginRight: 20,
    },
  },
  reportCardChipValue: {
    fontSize: 16,
    fontWeight: 600,
    [theme.breakpoints.up("md")]: {
      fontSize: 18,
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: 24,
    },
  },
  performanceCheckboxContainer: {
    display: "flex",
    marginLeft: "-14px",
    "& .MuiSvgIcon-root": {
      width: "1.5em",
      height: "1.5em",
    },
  },
  performanceCheckbox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "2em",
  },
  performanceCheckboxApiFailed: {
    pointerEvents: "none",
    "& .MuiIconButton-label": {
      color: "rgb(241, 242, 246)",
    },
    "& p": {
      color: "rgb(241, 242, 246)",
      "&:before": {
        background: "rgb(241, 242, 246)!important",
      },
    },
  },
  dateContent: {},
  downloadReportLink: {
    color: "rgba(36, 42, 56, .5)",
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    "&, &:hover, &:active": {
      textDecoration: "none",
    },
  },
  downloadReportLinkActive: {
    color: "rgba(36, 42, 56, 1)",
    cursor: "pointer",
  },
  downloadSpinnerIcon: {
    width: `${theme.typography.pxToRem(16)} !important`,
    height: `${theme.typography.pxToRem(16)} !important`,
    marginLeft: theme.spacing(1),
    color: "rgba(0,0,0,1)",
  },
  brakingLegend: {
    paddingTop: "12px",
    "&:before": {
      content: '""',
      marginBottom: "5px",
      width: "30px",
      height: "3px",
      display: "block",
      background: "rgb(250,100,0)",
    },
  },
  corneringLegend: {
    paddingTop: "12px",
    "&:before": {
      content: '""',
      marginBottom: "5px",
      width: "30px",
      height: "3px",
      display: "block",
      background: "rgb(0,98,250)",
    },
  },
  speedingLegend: {
    paddingTop: "12px",
    "&:before": {
      content: '""',
      marginBottom: "5px",
      width: "30px",
      height: "3px",
      display: "block",
      background: "rgb(200,0,250)",
    },
  },
  engagementLegend: {
    paddingTop: "12px",
    "&:before": {
      content: '""',
      marginBottom: "5px",
      width: "30px",
      height: "3px",
      display: "block",
      background: "rgb(105, 164, 22)",
    },
  },
  distractionLegend: {
    paddingTop: "12px",
    "&:before": {
      content: '""',
      marginBottom: "5px",
      width: "30px",
      height: "3px",
      display: "block",
      background: "#f9d037",
    },
  },
  accelerationLegend: {
    paddingTop: "12px",
    "&:before": {
      content: '""',
      marginBottom: "5px",
      width: "30px",
      height: "3px",
      display: "block",
      background: "#40E0D0",
    },
  },
  reportDropdownButton: {
    backgroundColor: "transparent",
    borderRadius: 0,
    padding: theme.spacing(4, 3),
    borderRight: "1px solid rgba(241, 242, 246, 1)",
    "&:hover, &:focus, &:active": {
      backgroundColor: "transparent",
    },
  },
  avgScoreLabel: {
    display: "block",
    fontSize: "12px",
    color: "rgba(174, 178, 186, 1)",
    marginTop: "2px",
  },
  exportCard: {
    marginBottom: "25pt"
    // display: "flex",    
    // flexDirection: "column",
    // [theme.breakpoints.up("md")]: {
    //   flexDirection: "row",
    // },
  },
  exportCardLink: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
  },
  exportCardWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
  },
  exportCardContent: {
    order: 1,
    padding: theme.spacing(4, 2),
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(4, 6, 8),
    },
    [theme.breakpoints.up("md")]: {
      order: 0,
      minWidth: "calc(100% - 250px)",
      width: "calc(100% - 250px)",
      flex: "0 0 calc(100% - 250px)",
    },
    [theme.breakpoints.up("lg")]: {
      order: 0,
      minWidth: "calc(100% - 350px)",
      width: "calc(100% - 350px)",
      flex: "0 0 calc(100% - 350px)",
    },
  },
  exportCardTitle: {
    color: "rgb(36, 42, 56)",
    fontSize: 18,
    fontWeight: 900,
    display: "none",
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      fontSize: 24,
    },
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: 18,
    },
  },
  exportCardDate: {
    color: "rgba(141, 141, 141, 1)",
    fontSize: 12,
    fontWeight: 500,
    display: "none",
    marginBottom: theme.spacing(2.5),
    [theme.breakpoints.up("sm")]: {
      fontSize: 14,
    },
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
  exportCardText: {
    color: "rgba(141, 141, 141, 1)",
    fontSize: 14,
    fontWeight: 400,
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up("lg")]: {
      maxWidth: "80%",
    },
  },
  downloadIcon: {
    width: 20,
    marginRight: theme.spacing(2),
  },
  exportCardButton: {
    "&.MuiButton-root": {
      height: "auto",
      fontSize: 14,
      fontWeight: 500,
      [theme.breakpoints.up("lg")]: {
        padding: theme.spacing(2.5, 4),
        borderRadius: 30,
      },
    },
  },
  exportCardButtonDisabled: {
    backgroundColor: "rgb(241,242,246)",
    cursor: "not-allowed",
    "&:hover, &:focus, &:active": {
      backgroundColor: "rgb(241,242,246)",
      boxShadow: "unset",
    },
  },
  exportCardImg: {
    background: "linear-gradient(to bottom, rgb(253, 234, 104), rgb(254, 121, 14))",
    // backgroundImage: `url(${reportBg})`,
    marginRight: '8px',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    padding: theme.spacing(3),
    "&.MuiCardContent-root:last-child": {
      padding: theme.spacing(3),
    },
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(4),
      "&.MuiCardContent-root:last-child": {
        padding: theme.spacing(4),
      },
    },
    [theme.breakpoints.up("md")]: {
      minWidth: 250,
      width: 250,
      flex: "0 0 250px",
    },
    [theme.breakpoints.up("lg")]: {
      minWidth: 350,
      width: 350,
      minHeight: 400,
      flex: "0 0 350px",
      padding: theme.spacing(10, 5),
      "&.MuiCardContent-root:last-child": {
        padding: theme.spacing(10, 5),
      },
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: '-5px',
    },
  },
  exportCardImgTitle: {
    color: "#000",
    fontSize: 16,
    fontWeight: 900,
    marginBottom: theme.spacing(2),
    // wordBreak: "break-all",
    [theme.breakpoints.up("sm")]: {
      fontSize: 20,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 30,
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: 40,
    },
  },
  exportCardImgDate: {
    color: "#fff",
    fontSize: 12,
    fontWeight: 500,
    [theme.breakpoints.up("sm")]: {
      fontSize: 14,
    },
  },
  exportCardContentLoader: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  reportCardChipApiFailed: {
    display: "inline-flex",
    marginRight: "20px",
    borderRadius: "42px",
    transform: "unset",
  },
  fleetPerformanceDisabled: {
    pointerEvents: "none",
  },
  btnSkeleton: {
    transform: 'scale(1,1) !important',
    borderRadius: '32px !important',
  },
  reportGraph: {

  },
  reportCardChipWrap: {},
}));
